export default {
  主页面标题: "寻源需求管理",
  申请寻源按钮: "申请寻源",
  导入寻源计划按钮: "导入寻源计划",
  导入寻源计划: "导入寻源计划",
  导入关闭: "关闭",
  导入确认: "确认",
  寻源类型: "寻源类型",
  点击下载: "点击下载",
  下载模版: "下载模版",
  寻源计划文件: "寻源计划文件",
  请上传寻源计划文件: "请上传寻源计划文件",
  点击上传: "点击上传",
  寻源信息: "寻源信息",
  工厂: "工厂",
  请选择工厂: "请选择工厂",
  寻源类别: "寻源类别",
  请选择寻源类别: "请选择寻源类别",
  寻源二级类别: "寻源二级类别",
  请选择二级寻源类别: "请选择二级寻源类别",
  成本中心: "成本中心",
  请选择成本中心: "请选择成本中心",
  序号: "序号",
  物料编号: "物料编号",
  物料名称: "物料名称",
  年采购数量: "年采购数量",
  请输入编号: "请输入编号",
  请输入物料名称: "请输入物料名称",
  请输入年采购数量: "请输入年采购数量",
  相关产品: "相关产品",
  请输入相关产品: "请输入相关产品",
  请输入要求完成日期: "请输入要求完成日期",
  寻源原因: "寻源原因",
  请输入寻源原因: "请输入寻源原因",
  寻源要求: "寻源要求",
  请输入寻源要求: "请输入寻源要求",
  寻源优先级: "寻源优先级",
  紧急: "紧急",
  一般: "一般",
  取消寻源: "取消寻源",
  取消原因: "取消原因",
  寻源来源: "寻源来源",
  寻源方法: "寻源方法",
  计划开始时间: "计划开始时间",
  计划结束时间: "计划结束时间",
  寻源执行: "寻源执行",
  查看寻源进度: "查看寻源进度",
  寻源名称: "寻源名称",
  需求数量: "需求数量",
  单价HKD: "单价HKD",
  总金额HKD: "总金额HKD",
  相关附件: "相关附件",
  现有标准物料文件: "现有标准物料文件",
  现有供应商COA: "现有供应商COA",
  URS文件: "URS文件",
  其他: "其他",
  取消寻源原因: "取消寻源原因",
  取消成功: "取消成功",
  请输入取消寻源的原因: "请输入取消寻源的原因",
  表单底部暂存: "暂存",
  表单底部提交: "提交",
  提交成功: "提交成功",
  寻源物料产品正在处方变更: "寻源物料产品正在处方变更",
  物料质量标准确认: "物料质量标准确认",
  供应商开发和筛选: "供应商开发和筛选",
  供应商选择和评估: "供应商选择和评估",
  供应商合格认证: "供应商合格认证（原供应商准入）",
  提供URS: "提供URS",
  用户与供应商技术沟通: "用户与供应商技术沟通",
  采购与供应商商务沟通: "采购与供应商商务沟通",
  汇总技术与商务资料: "汇总技术与商务资料",
  采购委员会获批: "采购委员会获批",
  合同签署获批: "合同签署获批",
  寻源需求申请: "寻源需求申请",
  寻源节点跟进: "寻源节点跟进",
  全部展开: "全部展开",
  全部折叠: "全部折叠",
  操作成功: "操作成功",
  完成节点: "完成节点",
  已完成: "已完成",
  待完成: "待完成",
  展开: "展开",
  折叠: "折叠",
  点击选择供应商: "点击选择供应商",
  处方变更确认: "处方变更确认",
  寻源物料之产品是否正在处方变更: "寻源物料之产品是否正在处方变更",
  请选择产品是否正在处方变更: "请选择产品是否正在处方变更",
  预计处方变更完成时间: "预计处方变更完成时间",
  请选择预计处方变更完成时间: "请选择预计处方变更完成时间",
  物料标准确认: "物料标准确认",
  现有物料标准是否可用于寻源: "现有物料标准是否可用于寻源",
  请选择现有物料标准是否可用于寻源: "请选择现有物料标准是否可用于寻源",
  新标准物料文件: "新标准物料文件",
  生产性物料: "生产性物料",
  非生产性物料: "非生产性物料",
  当前节点完成后无法取消: "当前节点完成后无法取消",
  寻源节点维护流程: "寻源节点维护流程",
  寻源申请状态: "寻源申请状态",
  寻源执行状态: "寻源执行状态",
  未开始: "未开始",
  进行中: "进行中",
  已取消: "已取消",
  寻源数量: "寻源数量",
  二级寻源类别: "二级寻源类别",
  寻源负责人: "寻源负责人",
  负责人: "负责人",
  搜索物料编号名称占位符: "请输入物料编号或名称搜索",
  重新提交: "重新提交",
  单价: "单价",
  总金额: "总金额",
  请输入: "请输入",
  请选择: "请选择",
  表单编号: "表单编号",
  物料: "物料",
  申请人: "申请人",
  要求完成日期: "要求完成日期",
};
